import css from "@/components/Listing/ListingScreen/.module.scss";
import React, { forwardRef } from "react";
import { financialFormat } from "@/lib/helpers";

export const Prices = forwardRef(function Prices({ listing }, ref) {
  if (
    !listing?.price_12_payments &&
    !listing?.price_2_payments &&
    !listing?.price_4_payments
  )
    return null;
  return (
    <>
      <h4>دفعات الإيجار</h4>
      <div className={css.prices} ref={ref}>
        {listing.price_2_payments ? (
          <div>
            <p>
              {listing.price_2_payments
                ? financialFormat(listing.price_2_payments, "ريال ")
                : "--"}
              على <strong>دفعتين</strong>
            </p>

            <p>
              {listing.price_2_payments
                ? financialFormat(listing.price_2_payments / 2, "ريال ")
                : "--"}
              لكل دفعة
            </p>
          </div>
        ) : null}
        {listing.price_4_payments ? (
          <div>
            <p>
              {listing.price_4_payments
                ? financialFormat(Math.round(listing.price_4_payments), "ريال ")
                : "--"}
              على <strong> 4 دفعات</strong>
            </p>

            <p>
              {listing.price_4_payments
                ? financialFormat(
                    Math.round(listing.price_4_payments / 4),
                    "ريال ",
                  )
                : "--"}
              لكل دفعة
            </p>
          </div>
        ) : null}

        {listing.price_12_payments ? (
          <div>
            <p>
              {listing.price_12_payments
                ? financialFormat(listing.price_12_payments, "ريال ")
                : "--"}
              على <strong>دفعات شهرية</strong>
            </p>

            <p>
              {listing.price_12_payments
                ? financialFormat(
                    Math.round(listing.price_12_payments / 12),
                    "ريال ",
                  )
                : "--"}
              لكل شهر
            </p>
          </div>
        ) : null}
      </div>
    </>
  );
});
